import React from 'react';
import { TabGridContianer } from './adminDetailTab.styled';
import AdminDetailTabList from './adminDetailTab';

const AdminDetailTabListContainer = ({
    accountDetailTabList,
    tabActiveId,
    tabSwitch,
}) => {
    return (
        <>
            <TabGridContianer>
                {accountDetailTabList.map((accountTab) => {
                    return (
                        <AdminDetailTabList
                            key={accountTab.id}
                            label={accountTab.label}
                            id={accountTab.id}
                            isTabActive={tabActiveId === accountTab.id}
                            tabSwitch={tabSwitch}
                        />
                    );
                })}
            </TabGridContianer>
        </>
    );
};

export default AdminDetailTabListContainer;
